
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/vpnpricecomparison/contact-us",
      function () {
        return require("private-next-pages/vpnpricecomparison/contact-us.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/vpnpricecomparison/contact-us"])
      });
    }
  